<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="m16.2 6.34-4.25 4.25L7.7 6.34 6.29 7.76 10.54 12l-4.25 4.24 1.42 1.42 4.24-4.25 4.24 4.25 1.42-1.42L13.36 12l4.25-4.24-1.42-1.42Z"
    fill="#8D939A"
  />
</svg>
